import React from "react";
import ReactDOM from "react-dom";
import OptionSwitcher from "../components/OptionSwitch";
import { initializeI18n } from "../localization/i18n";

window.renderOptionSwitcher = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {
    initializeI18n()
      .then(() => {
        ReactDOM.render(<OptionSwitcher {...props} />, element);
      })
      .catch((error) => {
      });
  } else {
  }
};